"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/*
query NotificationsMenuQuery {
  me {
    unreadNotificationsCount
    followsAndSaves {
      notifications: bundledArtworksByArtistConnection(sort: PUBLISHED_AT_DESC, first: 10) {
        edges {
          node {
            href
            summary
            artists
            published_at: publishedAt(format: "MMM DD")
            image {
              resized(height: 40, width: 40) {
                url
              }
            }
            id
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
    id
  }
}
*/
var node = function () {
  var v0 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "unreadNotificationsCount",
    "args": null,
    "storageKey": null
  },
      v1 = {
    "kind": "Literal",
    "name": "sort",
    "value": "PUBLISHED_AT_DESC"
  },
      v2 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "href",
    "args": null,
    "storageKey": null
  },
      v3 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "summary",
    "args": null,
    "storageKey": null
  },
      v4 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "artists",
    "args": null,
    "storageKey": null
  },
      v5 = {
    "kind": "ScalarField",
    "alias": "published_at",
    "name": "publishedAt",
    "args": [{
      "kind": "Literal",
      "name": "format",
      "value": "MMM DD"
    }],
    "storageKey": "publishedAt(format:\"MMM DD\")"
  },
      v6 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "image",
    "storageKey": null,
    "args": null,
    "concreteType": "Image",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "name": "resized",
      "storageKey": "resized(height:40,width:40)",
      "args": [{
        "kind": "Literal",
        "name": "height",
        "value": 40
      }, {
        "kind": "Literal",
        "name": "width",
        "value": 40
      }],
      "concreteType": "ResizedImageUrl",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      }]
    }]
  },
      v7 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "__typename",
    "args": null,
    "storageKey": null
  },
      v8 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "cursor",
    "args": null,
    "storageKey": null
  },
      v9 = {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }]
  },
      v10 = [{
    "kind": "Literal",
    "name": "first",
    "value": 10
  }, v1
  /*: any*/
  ],
      v11 = {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  };
  return {
    "kind": "Request",
    "fragment": {
      "kind": "Fragment",
      "name": "NotificationsMenuQuery",
      "type": "Query",
      "metadata": null,
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "me",
        "storageKey": null,
        "args": null,
        "concreteType": "Me",
        "plural": false,
        "selections": [v0
        /*: any*/
        , {
          "kind": "LinkedField",
          "alias": null,
          "name": "followsAndSaves",
          "storageKey": null,
          "args": null,
          "concreteType": "FollowsAndSaves",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": "notifications",
            "name": "__WorksForYou_notifications_connection",
            "storageKey": "__WorksForYou_notifications_connection(sort:\"PUBLISHED_AT_DESC\")",
            "args": [v1
            /*: any*/
            ],
            "concreteType": "FollowedArtistsArtworksGroupConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "FollowedArtistsArtworksGroupEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "FollowedArtistsArtworksGroup",
                "plural": false,
                "selections": [v2
                /*: any*/
                , v3
                /*: any*/
                , v4
                /*: any*/
                , v5
                /*: any*/
                , v6
                /*: any*/
                , v7
                /*: any*/
                ]
              }, v8
              /*: any*/
              ]
            }, v9
            /*: any*/
            ]
          }]
        }]
      }]
    },
    "operation": {
      "kind": "Operation",
      "name": "NotificationsMenuQuery",
      "argumentDefinitions": [],
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "name": "me",
        "storageKey": null,
        "args": null,
        "concreteType": "Me",
        "plural": false,
        "selections": [v0
        /*: any*/
        , {
          "kind": "LinkedField",
          "alias": null,
          "name": "followsAndSaves",
          "storageKey": null,
          "args": null,
          "concreteType": "FollowsAndSaves",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": "notifications",
            "name": "bundledArtworksByArtistConnection",
            "storageKey": "bundledArtworksByArtistConnection(first:10,sort:\"PUBLISHED_AT_DESC\")",
            "args": v10
            /*: any*/
            ,
            "concreteType": "FollowedArtistsArtworksGroupConnection",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "FollowedArtistsArtworksGroupEdge",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "FollowedArtistsArtworksGroup",
                "plural": false,
                "selections": [v2
                /*: any*/
                , v3
                /*: any*/
                , v4
                /*: any*/
                , v5
                /*: any*/
                , v6
                /*: any*/
                , v11
                /*: any*/
                , v7
                /*: any*/
                ]
              }, v8
              /*: any*/
              ]
            }, v9
            /*: any*/
            ]
          }, {
            "kind": "LinkedHandle",
            "alias": "notifications",
            "name": "bundledArtworksByArtistConnection",
            "args": v10
            /*: any*/
            ,
            "handle": "connection",
            "key": "WorksForYou_notifications",
            "filters": ["sort"]
          }]
        }, v11
        /*: any*/
        ]
      }]
    },
    "params": {
      "operationKind": "query",
      "name": "NotificationsMenuQuery",
      "id": null,
      "text": "query NotificationsMenuQuery {\n  me {\n    unreadNotificationsCount\n    followsAndSaves {\n      notifications: bundledArtworksByArtistConnection(sort: PUBLISHED_AT_DESC, first: 10) {\n        edges {\n          node {\n            href\n            summary\n            artists\n            published_at: publishedAt(format: \"MMM DD\")\n            image {\n              resized(height: 40, width: 40) {\n                url\n              }\n            }\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    id\n  }\n}\n",
      "metadata": {
        "connection": [{
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": ["me", "followsAndSaves", "notifications"]
        }]
      }
    }
  };
}();

node.hash = 'a8c3f9e7d3feccfe1672ba90644d64f1';
var _default = node;
exports.default = _default;
//# sourceMappingURL=NotificationsMenuQuery.graphql.js.map